import styled from 'styled-components';

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 15px;
  line-height: 26px;
  padding: 15px 30px 30px 30px;
  color: ${({ theme }) => theme.baseBlue.a6};
  .iconDanger {
    color: ${({ theme }) => theme.red.a10};
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 15px;
`;

export const ModalChipsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 15px;
  justify-content: center;
`;

export const ButtonMargin = styled.div`
  margin-right: 15px;
`;

export const CtaText = styled.span`
  margin-top: 30px;
`;
export const ModalTitle = styled.span`
  font-size: 21px;
  font-weight: 600;
  line-height: 35px;
  color: ${({ theme }) => theme.red.a10};
  margin-top: 15px;
`;
export const ModalSubTitle = styled.span`
  width: 100%;
  text-align: center;
`;
